import React, { useState } from "react";
import { DataTable } from "../Components";
import { useQuery } from "@tanstack/react-query";
import { API_POST_USERWISEPOSITIONHISTORY } from "../utils/api/ApiConstant";
import { postAxios } from "../Services/commonService";

const UserWiseScriptPositionHistory = ({ payloadData, rowData }) => {
  console.log("rowData", rowData);

  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [recordsPerPage, setRecordsPerPage] = useState(200);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRecordsperPage = (value) => {
    setRecordsPerPage(value);
  };

  const { isLoading, data: UserWiseScriptPositionHistory } = useQuery({
    queryKey: ["UserWiseScriptPositionHistory", payloadData],
    queryFn: async () => {
      const param = {
        server: rowData?.ServerName,
        PositionDate: payloadData?.PositionDate,
        ScriptToken: rowData?.ScriptToken,
      };

      const res = await postAxios({
        url: API_POST_USERWISEPOSITIONHISTORY,
        payload: param,
      });

      return res || [];
    },
    // refetchInterval: 1 * 60 * 1000,
  });
  console.log(
    "🚀 ~ UserWiseScriptPositionHistory ~ UserWiseScriptPositionHistory:",
    UserWiseScriptPositionHistory
  );

  const fetchData = () => {
    if (!UserWiseScriptPositionHistory) return { data: [], pages: 0 };

    const startIndex = (currentPage - 1) * recordsPerPage;
    const endIndex = startIndex + recordsPerPage;

    const filterData = UserWiseScriptPositionHistory.filter((item) => {
      const searchMatch =
        !searchTerm ||
        Object.values(item).some((val) =>
          String(val).toLowerCase().includes(searchTerm.toLowerCase())
        );
      return searchMatch;
    });
    return {
      data: filterData.slice(startIndex, endIndex),
      pages: Math.ceil(filterData.length / recordsPerPage),
    };
  };

  const columns = [
    {
      accessorKey: "PositionDateOn",
      header: "Position Date On",
      cell: ({ getValue }) => {
        const rawDate = getValue();
        const date = new Date(rawDate);

        const options = {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
          timeZone: "Asia/Kolkata", // force IST
        };

        return date.toLocaleString("en-IN", options);
      },
    },
    // {
    //   accessorKey: "ServerName",
    //   header: "Server Name",
    // },
    {
      accessorKey: "UserName",
      header: "UserName",
      cell: ({ getValue }) => {
        const value = getValue().toLowerCase();
        return <div>{value}</div>;
      },
    },
    {
      accessorKey: "ParentUser",
      header: "ParentUser",
      cell: ({ getValue }) => {
        const value = getValue().toLowerCase();
        return <div>{value}</div>;
      },
    },
    {
      accessorKey: "DisplayName",
      header: "DisplayName",
      cell: ({ getValue }) => {
        const value = getValue().toLowerCase();
        return <div>{value}</div>;
      },
    },
    { accessorKey: "Description", header: "Description" },
    // {
    //   accessorKey: "ExchangeName",
    //   header: "Exchange",
    // },
    // {
    //   accessorKey: "Script",
    //   header: "Script",
    // },
    // {
    //   accessorKey: "ExpiryDateText",
    //   header: "Exp. Date",
    // },
    {
      accessorKey: "Position",
      header: "Position",
      cell: ({ row, getValue }) => {
        return (
          <div
            style={{
              cursor: "pointer",
              color: getValue() === "BUY" ? "green" : "red",
            }}
          >
            {getValue()}
          </div>
        );
      },
    },
    {
      accessorKey: "OpenQuantity",
      header: "Open Qty",
      cell: ({ row, getValue }) => {
        return (
          <div
            className="text-end"
            style={{
              cursor: "pointer",
              color: Number(getValue()) > 0 ? "green" : "red",
            }}
          >
            {getValue()}
          </div>
        );
      },
    },
    {
      accessorKey: "BuyQty",
      header: "Buy Qty",
      cell: ({ getValue }) => {
        const value = getValue();
        return <div className="text-end">{value}</div>;
      },
    },
    {
      accessorKey: "SellQty",
      header: "Sell Qty",
      cell: ({ getValue }) => {
        const value = getValue();
        return <div className="text-end">{value}</div>;
      },
    },
    {
      accessorKey: "OpenAvgRate",
      header: "Avg Rate",
      cell: ({ getValue }) => {
        const value = getValue();
        return <div className="text-end">{value}</div>;
      },
    },
    {
      accessorKey: "BuyPrice",
      header: "Buy Price",
      cell: ({ getValue }) => {
        const value = getValue();
        return <div className="text-end">{value}</div>;
      },
    },
    {
      accessorKey: "SellPrice",
      header: "Sell Price",
      cell: ({ getValue }) => {
        const value = getValue();
        return <div className="text-end">{value}</div>;
      },
    },
    {
      accessorKey: "PositionDate",
      header: "Position Date",
      cell: ({ getValue }) => {
        const rawDate = getValue();
        const date = new Date(rawDate);

        const options = {
          day: "2-digit",
          month: "short",
          year: "numeric",
        };

        return date.toLocaleString("en-IN", options);
      },
    },
    {
      accessorKey: "PositionDays",
      header: "Position Days",
    },
    {
      accessorKey: "CurrentMapPrice",
      header: "CMP",
      cell: ({ row, getValue }) => {
        return (
          <div className="text-end" style={{ cursor: "pointer" }}>
            {getValue()}
          </div>
        );
      },
    },
    {
      accessorKey: "ProfitLoss",
      header: "P&L",
      cell: ({ row, getValue }) => {
        return (
          <div className="text-end" style={{ cursor: "pointer" }}>
            {getValue()}
          </div>
        );
      },
    },
    {
      accessorKey: "RealizedPL",
      header: "RealizedPL",
      cell: ({ row, getValue }) => {
        return (
          <div className="text-end" style={{ cursor: "pointer" }}>
            {getValue()}
          </div>
        );
      },
    },
  ];

  return (
    <>
      <DataTable
        columns={columns}
        // fetchData={fetchData}
        data={fetchData().data}
        pages={fetchData().pages}
        isLoading={isLoading}
        currentPage={currentPage}
        onPageChange={handlePageChange}
        onRecordsPerPageChange={handleRecordsperPage}
        recordsPerPage={recordsPerPage}
        isSearchable={true}
        searchTerm={searchTerm}
        onSearchChange={(val) => setSearchTerm(val)}
        isPagination={true}
        isPageSize={true}
        isIndexing={true}
      />
    </>
  );
};

export default UserWiseScriptPositionHistory;
